import store from "../../store";
import pos from './pos.vue';

window.POS_COMPONENT =  new Vue({
    store,
    el: 'div#pos_block',

    name : "POS_COMPONENT",
    data () {
        return {

        }
    },
    created () {

    },
    components : {
        pos,
    }
});
